import { styled } from 'styled-components'
import { Link } from 'react-router'

const RouteLink = styled(Link)`
  text-decoration: none;
  color: unset;
`

export default RouteLink
